/* eslint-disable */
// @ts-nocheck
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Tag } from "@carbon/react";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import SectionHeader from "../components/section/SectionHeader";
import {
  ADD_MCPTT_USER_FORM_FIELDS,
  EDIT_MCPTT_USER_FORM_FIELDS,
  MCPTT_USERS_FILTER_COLUMNS,
  MCPTT_USERS_TABLE_HEADERS,
} from "../constants";
import AuthContext from "../store/authContext";
import {
  createSearchConfig,
  errorAlert,
  makeApiRequest,
  successAlert,
  transformMCPTTUsersResponseRow,
  transformMCPTTUsersRows,
  transformMCPTTUsersUpdateBody,
} from "../util";
import DataTableWithControls from "../components/dataTable/DataTableWithControls";
import OrgContext from "../store/orgContext";
import InfoAlert from "../ui/InfoAlert";
import TableActionButton from "../ui/TableActionButton";
import AdvancedSearch from "../components/advancedSearch/AdvancedSearch";
import {
  deleteMCPTTUser,
  getMCPTTUserByRef,
  updateMCPTTUserByRef,
} from "../api";
import EditRow from "../components/dataTable/EditRow";
import { INITIAL_MCPTT_USERS_EDIT_STATE } from "../constants/editState";
import useHideSidePanel from "../hooks/useHideSidePanel";
import {
  DELETE_MCPTT_USER_TRANSLATIONS,
  READ_MCPTT_USER_TRANSLATIONS,
} from "../translations/util";
import useAppTitle from "../hooks/useAppTitle";
import SearchContext from "../store/searchContext";
import { mappedFieldList } from "../constants/editFormFields";
import BulkUpload from "../components/bulkUpload/BulkUpload";

interface ISearchData {
  "MCPTT-ID"?: string | null;
  "MAPPED-P25-ID"?: string | null;
  "MAPPED-DMR-ID"?: string | null;
  "MAPPED-ROIP-ID"?: string | null;
  "MAPPED-DFSI-ID"?: string | null;
  "DISPLAY-NAME"?: string | null;
  "MUTUAL-AID"?: string | null;
}

const INITIAL_STATE = {
  "MCPTT-ID": "",
  "MAPPED-P25-ID": "",
  "MAPPED-DMR-ID": "",
  "MAPPED-ROIP-ID": "",
  "MAPPED-DFSI-ID": "",
  "DISPLAY-NAME": "",
  "MUTUAL-AID": "",
};

const searchFields = [
  "MCPTT-ID",
  "MAPPED-P25-ID",
  "MAPPED-DMR-ID",
  "MAPPED-ROIP-ID",
  "MAPPED-DFSI-ID",
  "DISPLAY-NAME",
  "MUTUAL-AID",
];

const searchConfigNew = createSearchConfig(searchFields, [
  ...mappedFieldList,
  ...ADD_MCPTT_USER_FORM_FIELDS,
]);

const MCPTTUsers = () => {
  const {
    token,
    scopes: { mc_users: mcpttUsers },
  } = useContext(AuthContext);
  const { orgs: orgList, selectedOrg, updateOrg } = useContext(OrgContext);
  const { selectedColumn, setSelectedColumn, setSearchText, setDisableSearch } =
    useContext(SearchContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [usersData, setUsersData] = useState<any[]>([]);

  // State to check if Bulk Upload is Clicked
  const [isBulkUploadEnabled, setIsBulkUploadEnabled] = useState(false);

  //Ref - to hold mutual aid user data
  const mutualAidUserRef = useRef([]);

  const {
    showSidePanel,
    showAdvancedSearch,
    handleToggleAdvanceSearchPanel,
    handleToggleSidePanel,
  } = useHideSidePanel();
  const [selectedConnectionId, setSelectedConnectionId] = useState<
    string | null
  >(null);

  const [searchData, setSearchData] = useState<ISearchData>(INITIAL_STATE);
  useAppTitle("MCPTT Users- IWF Config Admin Tool (ICAT) by AT&T");
  const [numberOfRows, setNumberOfRows] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [flagged, setFlagged] = useState(false);
  const [isPaginated, setIsPaginated] = useState(false);
  const [searchQuery, setSearhQuery] = useState<{
    data: ISearchData;
    pageNum: number;
    pageSize: number;
    sortByField?: string;
    sortDirection?: "desc" | "asc";
  }>({
    pageSize: 20,
    pageNum: 1,
    data: {},
    sortByField: undefined,
    sortDirection: undefined,
  });

  const fetchMCPTTUsers = async () => {
    setLoading(true);
    try {
      if (selectedOrg) {
        const { data, pageNum, pageSize, sortByField, sortDirection } =
          searchQuery;
        // to fetch the data which has Mutual-Aid set to true
        const mutualAidQueryParams = new URLSearchParams({
          ...{
            "MUTUAL-AID": "1",
          },
        });
        // search params for MCPTT User data
        const queryParams = new URLSearchParams({
          page: `${pageNum}`,
          pageSize: `${pageSize}`,
          ...(sortByField && { sortByField }),
          ...(sortDirection && { sortDirection }),
          ...(data &&
            data["MCPTT-ID"] && {
              "MCPTT-ID": data["MCPTT-ID"],
            }),
          ...(data &&
            data["DISPLAY-NAME"] && {
              "DISPLAY-NAME": data["DISPLAY-NAME"],
            }),
          ...(data &&
            data["MAPPED-P25-ID"] && {
              "MAPPED-P25-ID": data["MAPPED-P25-ID"],
            }),
          ...(data &&
            data["MAPPED-DMR-ID"] && {
              "MAPPED-DMR-ID": data["MAPPED-DMR-ID"],
            }),
          ...(data &&
            data["MAPPED-ROIP-ID"] && {
              "MAPPED-ROIP-ID": data["MAPPED-ROIP-ID"],
            }),
          ...(data &&
            data["MAPPED-DFSI-ID"] && {
              "MAPPED-DFSI-ID": data["MAPPED-DFSI-ID"],
            }),
          ...(data &&
            ["true", "false"].includes(data["MUTUAL-AID"]?.toLowerCase()) && {
              "MUTUAL-AID":
                data["MUTUAL-AID"]?.toLowerCase() === "true" ? "1" : "0",
            }),
        });
        // Search 1: this API is called to fetch Mutual-AId data (if it exists)
        const result = await makeApiRequest<{
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          Rows: Array<any>;
        }>({
          path: `/api/v1/mc-users?${mutualAidQueryParams}`,
          token,
          org: selectedOrg.id,
        });
        mutualAidUserRef.current = result.Rows;
        // Search 2: this API is called to fetch mc user data
        const response = await makeApiRequest<{
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          Rows: Array<any>;
          NbrOfRows: number;
          NbrOfPages: number;
          Page: Number;
        }>({
          path: `/api/v1/mc-users?${queryParams}`,
          token,
          org: selectedOrg.id,
        });
        setNumberOfRows(response.NbrOfRows);
        setNumberOfPages(response.NbrOfPages);

        let filteredData = [];
        /**
         * flag to decide if data should be filtered -- in case search is applied then we do not
         *  need to append mutual-aid record into the final result.
         */

        const shouldFilterData =
          !data["MUTUAL-AID"] &&
          !data["MCPTT-ID"] &&
          !data["DISPLAY-NAME"] &&
          !data["MAPPED-P25-ID"] &&
          !data["MAPPED-DMR-ID"] &&
          !data["MAPPED-ROIP-ID"] &&
          !data["MAPPED-DFSI-ID"];
        // removing duplicate data(filtering out mutual-aid data)
        filteredData =
          mutualAidUserRef.current[0] && shouldFilterData
            ? response.Rows.filter(
                (row) =>
                  row["MCPTT-ID"] !== mutualAidUserRef.current[0]?.["MCPTT-ID"],
              )
            : response.Rows;

        if (pageNum === 1 && mutualAidUserRef.current[0] && shouldFilterData) {
          // to show mutual-aid user on top of page=1 of table
          setUsersData([...mutualAidUserRef.current, ...filteredData]);
        } else {
          setUsersData([...filteredData]);
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      errorAlert(e);
    } finally {
      setLoading(false);
      setIsPaginated(false);
    }
  };

  const sortTable = (col: string, direction: "asc" | "desc") => () => {
    setSearhQuery({
      ...searchQuery,
      sortByField: col,
      sortDirection: direction,
    });
  };

  useEffect(() => {
    setSelectedColumn(null);
    setSearchText("");
    setDisableSearch(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSearchData(INITIAL_STATE);
    setSearhQuery({
      pageSize: 20,
      pageNum: 1,
      data: {},
      sortByField: undefined,
      sortDirection: undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrg]);

  useEffect(() => {
    fetchMCPTTUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrg, searchQuery]);

  useEffect(() => {
    if (!showAdvancedSearch && Object.keys(searchQuery.data).length === 0) {
      setSearchData(INITIAL_STATE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAdvancedSearch]);

  const deleteConnection = async (ref: string) => {
    if (selectedOrg && token) {
      try {
        await deleteMCPTTUser({
          token,
          org: selectedOrg.id,
          ref,
        });
        successAlert(DELETE_MCPTT_USER_TRANSLATIONS.successAlertMessage);
        handleToggleSidePanel();
        setSelectedConnectionId(null);
        fetchMCPTTUsers();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        errorAlert(e);
      }
    }
  };

  return (
    <>
      <SectionHeader
        pageTitle={READ_MCPTT_USER_TRANSLATIONS.header}
        pageDescription={READ_MCPTT_USER_TRANSLATIONS.headerSubtext}
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown
              org={selectedOrg || undefined}
              orgsList={orgList}
              setOrg={updateOrg}
            />
          </div>
        }
      />

      {selectedOrg ? (
        <>
          {showAdvancedSearch ? (
            <AdvancedSearch
              setShowAdvancedSearch={handleToggleAdvanceSearchPanel}
              advancedSearchState={searchData}
              advancedSearchConfig={searchConfigNew}
              setAdvancedSearchState={setSearchData}
              onSubmit={(data) =>
                setSearhQuery({
                  ...searchQuery,
                  pageNum: 1,
                  pageSize: 20,
                  data,
                })
              }
              onCancel={() => {
                setSearchData(INITIAL_STATE);
                handleToggleAdvanceSearchPanel();
              }}
            />
          ) : null}

          {showSidePanel && isBulkUploadEnabled ? (
            <BulkUpload
              moduleName="MCPTT User"
              pathName="/api/v1/mc-users"
              csvTemplateFile={[
                "MCPTT-ID,DISPLAY-NAME,MAPPED-P25-ID,MAPPED-DFSI-ID,MAPPED-ROIP-ID,MAPPED-DMR-ID,MUTUAL-AID",
              ]}
              closeBulkUploadSidePanel={() => {
                handleToggleSidePanel();
                setIsBulkUploadEnabled(false);
                fetchMCPTTUsers();
              }}
            />
          ) : null}

          {showSidePanel &&
          selectedOrg &&
          selectedConnectionId &&
          !isBulkUploadEnabled ? (
            <EditRow
              panelName={READ_MCPTT_USER_TRANSLATIONS.editRow.panelName}
              initialState={INITIAL_MCPTT_USERS_EDIT_STATE}
              org={selectedOrg.id}
              esRef={selectedConnectionId}
              setShowEditPanel={handleToggleSidePanel}
              onDelete={() => deleteConnection(selectedConnectionId)}
              formFields={EDIT_MCPTT_USER_FORM_FIELDS}
              header={READ_MCPTT_USER_TRANSLATIONS.editRow.header}
              showSmallSidepanel
              transformResponseRow={transformMCPTTUsersResponseRow}
              transformUpdateBody={transformMCPTTUsersUpdateBody}
              onUpdate={updateMCPTTUserByRef}
              loadDataByRef={getMCPTTUserByRef}
              hasDeletePermission={mcpttUsers && mcpttUsers.includes("d")}
              hasEditPermission={mcpttUsers && mcpttUsers.includes("u")}
              refreshTable={fetchMCPTTUsers}
              deleteModalItemName="MCPTT-ID"
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              customValidationFn={(data: any) => {
                // send true on invalid
                if (data["MAPPED-P25-ID"] && data["MAPPED-P25-ID"].length > 0) {
                  return false;
                }
                if (data["MAPPED-DMR-ID"] && data["MAPPED-DMR-ID"].length > 0) {
                  return false;
                }
                if (
                  data["MAPPED-ROIP-ID"] &&
                  data["MAPPED-ROIP-ID"].length > 0
                ) {
                  return false;
                }
                if (
                  data["MAPPED-DFSI-ID"] &&
                  data["MAPPED-DFSI-ID"].length > 0
                ) {
                  return false;
                }
                return true;
              }}
              flagged={flagged}
              setFlagged={setFlagged}
            />
          ) : null}

          <DataTableWithControls
            loading={loading}
            filterColumns={MCPTT_USERS_FILTER_COLUMNS}
            selectedColumn={selectedColumn}
            setSelectedColumn={setSelectedColumn}
            onSearch={(term) =>
              setSearhQuery({
                ...searchQuery,
                pageNum: 1,
                pageSize: 20,
                data: { [`${selectedColumn?.id}`]: term },
              })
            }
            setShowAdvancedSearch={handleToggleAdvanceSearchPanel}
            showCreateButton={mcpttUsers && mcpttUsers.includes("c")}
            onCreateButtonClick={() => {
              navigate(`/configurationManagement/mcpttUsers/new`);
            }}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            rows={transformMCPTTUsersRows(usersData).map((row: any) => ({
              ...row,
              "MCPTT-ID": row["MUTUAL-AID"] ? (
                <div className="flex items-center gap-4 ">
                  {row["MCPTT-ID"]}
                  <Tag
                    tag="Mutual-Aid"
                    type="default"
                    size="default"
                    filter={false}
                    disabled={false}
                    className="active-channel"
                    data-cy="lmr-user-mutual-aid"
                  >
                    <span className="mutual-aid-pill">Mutual-Aid</span>
                  </Tag>
                </div>
              ) : (
                row["MCPTT-ID"]
              ),
              action: (
                <TableActionButton
                  onActionButtonClick={() => {
                    setSelectedConnectionId(row.id);
                    handleToggleSidePanel();
                  }}
                />
              ),
            }))}
            numberOfAdvancedSearchFilters={searchConfigNew.reduce(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (acc, el: any) => {
                const { name } = el;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const obj: any = { ...searchData };
                return acc + (obj[name] && obj[name].length > 0 ? 1 : 0);
              },
              0,
            )}
            clearAdvancedSearchFilters={() => {
              setSearchData(INITIAL_STATE);
              setSearhQuery({
                ...searchQuery,
                pageNum: 1,
                pageSize: 20,
                data: {},
              });
            }}
            headers={MCPTT_USERS_TABLE_HEADERS}
            pageNum={searchQuery.pageNum}
            setPageNum={(pageNum) => {
              setIsPaginated(true);
              setSearhQuery({ ...searchQuery, pageNum });
            }}
            totalItems={numberOfRows}
            totalPages={numberOfPages}
            pageSize={searchQuery.pageSize}
            setPageSize={(pageSize) =>
              setSearhQuery({ ...searchQuery, pageSize })
            }
            sortByField={searchQuery.sortByField}
            sortDirection={searchQuery.sortDirection}
            handleSort={sortTable}
            showBulkUploadButton={mcpttUsers && mcpttUsers.includes("c")}
            onBulkUploadButtonClick={() => {
              handleToggleSidePanel();
              setIsBulkUploadEnabled(true);
            }}
          />
        </>
      ) : (
        <InfoAlert
          heading={READ_MCPTT_USER_TRANSLATIONS.infoAlert.heading}
          subText={READ_MCPTT_USER_TRANSLATIONS.infoAlert.subText}
        />
      )}
    </>
  );
};

export default MCPTTUsers;
